<template>
   <div>
      <v-hover v-slot="{ hover }">
         <v-img :src="src"
                @click="onClick"
                class="cover"
                :gradient="gradientCss"
                :class="{ 
                     'hovered': (!noHover && hover), 
                     'clickable': !noPointer,
                     'rounded-xl': shaped
                  }">
             <template v-slot:placeholder>
                 <v-skeleton-loader
                   type="card"
                 ></v-skeleton-loader>
             </template>
         </v-img>
      </v-hover>
      <v-progress-linear indeterminate v-if="loading" />
   </div>
</template>

<style lang="scss">
   .cover {

      -webkit-transition: all .3s;
      transition        : all .3s;

      &.clickable {
         cursor: pointer;
      }

      &.hovered {
         transform: translateY(-5px);
         box-shadow: 0 5px 20px #2196f3;
      }

   }
</style>

<script>
export default {
   name: 'Cover',

   mixins: [],
   
   components: {},

   data: () => ({

   }),

   props: {
      loading: {
         type: Boolean,
         default: false
      },
      gradient: {
         type: Boolean,
         default: false
      },
      noPointer: {
         type: Boolean,
         default: false
      },
      src: {
         type: String,
         required: true
      },
      noHover: {
         type: Boolean,
         default: false
      },
      shaped:
      {
         type: Boolean,
         default: false
      },
   },

   computed: 
   {
      gradientCss()
      {
         return this.gradient ? 'to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)' : ''
      }
   },

   methods:
   {
      onClick()
      {
         this.$emit('click')
      }
   },

   load(){}
}
</script>